import { ToolbarButton } from '@fourthwall/components';
import { CloseIcon } from '@fourthwall/icons';
import React from 'react';
import * as S from './styled';
export const RuleLayout = ({ top, bottom, onRemove }) => (React.createElement(S.Container, null,
    React.createElement(S.InputsContainer, null,
        React.createElement("div", null, top),
        React.createElement(S.Bottom, null, bottom)),
    React.createElement(ToolbarButton, { icon: CloseIcon, size: "small", onClick: onRemove })));
